module.exports = __webpack_public_path__ + "img/part5-4.01bfc1e0.png";